import { Link } from 'react-router';
import { shellCopy } from '@/copy/shell';
import { Wordmark } from './kit';
import { Part } from './Part';
import { headerActions } from './registry';
import { SyncChip } from './SyncChip';

/**
 * The thin shell header: the sticker wordmark on the left (back to Home), the module header
 * actions on the right (the push bell lives there). Lilac ground, ink rule underneath.
 */
export function Header() {
  const actions = headerActions();
  return (
    <header className="tts-pt-safe sticky top-0 z-(--z-header) border-b-3 border-ink bg-ground">
      <div className="tts-px-safe mx-auto flex h-(--tts-header-h) max-w-2xl items-center justify-between gap-3">
        <Link to="/" aria-label={shellCopy.header.home} className="-ml-1 flex items-center p-1">
          <Wordmark variant="sticker" width={68} />
        </Link>
        <div className="flex min-w-0 flex-1 justify-end">
          <SyncChip />
        </div>
        <div className="flex items-center gap-2">
          {actions.map((a) => (
            <Part
              key={a.id}
              name={`${a.module}:${a.id}`}
              loader={a.component}
              fallback={<span className="size-11" />}
            />
          ))}
        </div>
      </div>
    </header>
  );
}
